import { getCurrentUserDetail } from "@payping/redux/actions";
import { Layout } from "@payping/web-components";
import classNames from "classnames";
import React, { Suspense, lazy } from "react";
import { useAsync } from "react-use";

import { TOTPModal } from "@/components/TOTPModal";
import { useHantanaConfig } from "@/utils/useHantanaConfig";
import { useAppDispatch, useAppSelector } from "@/utils/redux";
import DashboardTools from "@/components/DashboardTools";
import styles from "../assets/scss/Main.module.scss";
import AppMainNav from "../components/AppMainNav";
import Help from "../components/Help";
import componentLoader from "../utils/componentLoader";
import Loading from "./loading";
import { GoftinoProvider } from "@/utils/Goftino";
// import { usePrefetchPages } from "../utils/usePrefetchPages";

const RouterSwitch = lazy(() => componentLoader(() => import(/* webpackPreload: true */ "../router/RouterSwitch"), 3));

const Main: React.FC = () => {
  const locale = useAppSelector((state) => state.settings.locale);
  const dispatch = useAppDispatch();
  useAsync(() => dispatch(getCurrentUserDetail()), [dispatch]);
  useHantanaConfig();



  return (
    <GoftinoProvider chatId="G9nFLf">
      <Layout className={classNames(styles.container, locale === "en" ? "en-font" : "")}>
          <AppMainNav />
          <Suspense fallback={<Loading />}>
            <RouterSwitch />
          </Suspense>
          <Help />
          <TOTPModal />
          <DashboardTools />
        </Layout>
    </GoftinoProvider>
  );
};

export default Main;
